import axios from 'axios'

document.addEventListener('DOMContentLoaded', () => {
  $('#vm-cause-area-select').select2({
    placeholder: 'ex. Animals',
    minimumInputLength: 0,
    ajax: {
      url: '/volunteer_match_api/filters',
      dataType: 'json',
      delay: 0,
      data: function (params) {
        return {
          q: params.term // search term
        }
      },
      processResults: function (data, _params) {
        // parse the results into the format expected by Select2
        // TODO: Clean up formatting function
        return {
          results: data.map((el) => {
            return {
              id: el['name'],
              text: el['name']
                //Prepend capital letters with space
                .replace(/([A-Z])/g, ' $1')
                .trim()
                // Lowercase all first letters
                .replace(/\b[A-Z][a-z]+\b/g, (word) => word.toLowerCase())
                // Capitalize first letter
                .replace(/^[a-z]/g, (first) => first.toUpperCase())
            }
          }),
          cache: true
        }
      }
    }
  })

  $('#vm-great-for-select').select2({
    placeholder: 'ex. Great for Groups'
  })

  $(document).on('select2:select', '.autocomplete-search-general', async (e) => {
    const { params: eventParams, currentTarget } = e
    // The flow here is that, if the user selects a charity that exists in Candid but but not in our database,
    // we show the charity info in the UI immediately and spool off a request to create the charity in our database afterward.
    // This keeps the user experience snappy and gives us time to work behind-the-scenes
    if (eventParams?.data?.charity?.source === 'candid') {
      const { data: apiData } = await axios.post('/charities/search', {
        ein: eventParams.data.charity.ein
      })

      // Since our donation flow works off of charity IDs, we need to update the value of the placeholder
      // option elements to match the new ID created in our database.
      //
      // Failure is handled by failing the entire donation. This _should_ be a rare edge case, but at least
      // with this approach we'll be notified that something's up
      if (apiData?.charity?.id) {
        // Select2 doesn't handle updating the value of an option in-place well. This manifests by options
        // changing order and, in rare cases, hiding when you add further options (only seems to impact firefox and only sometimes)
        // I imagine they keep some internal cache of the options and don't update it when the value changes.
        // Given that, we have to remove the old option and add a new one with the updated value.
        // In practice this actually works really well and doesn't provide any UI hiccups.
        const { text: optionLabel, id: optionValue } = eventParams.data
        const updatedCharityOption = new Option(optionLabel, String(apiData.charity.id), true, true)
        // Preserve title for chip formatting
        updatedCharityOption.setAttribute('title', eventParams.data.title)

        document.querySelector(`option[value="${optionValue}"]`)?.remove()

        $(currentTarget)
          .append(updatedCharityOption)
          .trigger('change')
          // This will effectively call this parent function again since we're
          // re-triggering the select2:select event. However, since we're now saying
          // the source is local (which it is), we don't repeat this block. That said,
          // be mindful in future updates to not cause an infinite loop.
          .trigger({
            type: 'select2:select',
            params: {
              data: {
                ...eventParams.data,
                id: String(apiData.charity.id),
                charity: {
                  ...eventParams.data.charity,
                  id: String(apiData.charity.id),
                  source: 'local'
                }
              }
            }
          })
      }
    }
  })

  $(document).on('change', '.autocomplete-search-general', (e) => {
    // This is to allow Stimulus to consume Select2 events as normal JS events
    e.target.dispatchEvent(new Event('select2:change'))
  })
})
